"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.map");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var colors = _tokens.default.colors,
    spacing = _tokens.default.spacing;

var IconBusiness = function IconBusiness(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var sizeArray = Object.entries(spacing.icons);
  var colorArray = Object.entries(colors.icons);
  var sizeOptions = new Map(sizeArray);
  var displaySize = sizeOptions.get(props.size);
  var colorOptions = new Map(colorArray);
  var displayColor = colorOptions.get(props.color);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color && displayColor,
    "aria-hidden": !title,
    role: title ? "img" : null,
    width: props.size && displaySize,
    height: props.size && displaySize,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0.5 C12.1045695,0.5 13,1.3954305 13,2.5 L13,2.5 L13,4.5 L13,4.5 L14,4.5 C15.1045695,4.5 16,5.3954305 16,6.5 L16,6.5 L16,13.5 C16,14.6045695 15.1045695,15.5 14,15.5 L14,15.5 L2,15.5 C0.8954305,15.5 0,14.6045695 0,13.5 L0,13.5 L0,6.5 C0,5.3954305 0.8954305,4.5 2,4.5 L2,4.5 L3,4.5 L3,2.5 C3,1.3954305 3.8954305,0.5 5,0.5 L5,0.5 Z M14,6.5 L2,6.5 L2,13.5 L14,13.5 L14,6.5 Z M11,2.5 L5,2.5 L5,4.5 L11,4.5 L11,2.5 Z",
    fill: "#242934",
    fillRule: "nonzero"
  })));
};

IconBusiness.propTypes = {
  title: _propTypes.default.string,
  titleId: _propTypes.default.string,
  size: _propTypes.default.oneOf(["sm", "md"]),
  color: _propTypes.default.oneOf(["primaryBlue", "secondaryBlue", "darkGrey", "white"])
};
IconBusiness.defaultProps = {
  size: "sm",
  color: "darkGrey",
  focusable: !1
};
var _default = IconBusiness;
exports.default = _default;